import React from 'react';
import { Link } from 'react-router-dom'; // For internal navigation like the "Home" breadcrumb
import './Sectors.css'; // We'll create this CSS file next

const Sectors = () => {
  // Data for the icon boxes for easier management
  const sectorIcons = [
    { icon: 'fas fa-flask', name: 'Chemistry', link: '#' }, // Use FontAwesomeIcon component if not using global CSS classes
    { icon: 'fas fa-pills', name: 'Pharmaceutical', link: '#' },
    { icon: 'fas fa-drumstick-bite', name: 'Food', link: '#' },
    { icon: 'fas fa-gem', name: 'Transportation', link: '#' }, // Note: original HTML uses fa-gem for Transportation, might need specific icon
    { icon: 'fas fa-shipping-fast', name: 'Minerals', link: '#' },
    { icon: 'fas fa-tree', name: 'Packaging', link: '#' }, // Note: original HTML uses fa-tree for Packaging, might need specific icon
    { icon: 'fas fa-tractor', name: 'Agriculture', link: '#' }, // Changed from fa-gem for better representation
    { icon: 'fas fa-cubes', name: 'Mining', link: '#' }, // Corrected typo "Minig"
    { icon: 'fas fa-trash', name: 'Waste Transportation', link: '#' } // Ensured correct Font Awesome class
  ];

  return (
    <div className="sectors-page"> {/* Wrapper class for page-specific styling */}
      {/* ======= Breadcrumbs ======= */}
      <section id="breadcrumbs" className="breadcrumbs">
        <div className="container">
          <ol>
            <li><Link to="/">Home</Link></li>
            <li>Sectors</li>
          </ol>
        </div>
      </section>{/* End Breadcrumbs */}

      <main id="main">
        <section id="sectors-content" className="services-section"> {/* Changed id to be more specific and used class from about.css */}
          <div className="container">
            <div className="section-title" data-aos="fade-up">
              <h2>Sectors</h2>
              <div className="title-bar"></div> {/* Reusing title-bar from about.css */}
            </div>

            <div className="row"> {/* Bootstrap-like row */}
              <div className="col-md-6 align-items-stretch content-column">
                {/* Reusing about-card for consistent styling */}
                <div className="about-card">
                  <p>
                    <span className="text-logo">ABP Big Bag's</span> product groups are Big Bags, PP Sacks, PP Twines,
                    and Kraft Sacks. ABP also produces several other special products, including Container Safety Sheets, Thermal Blanket and Container Liners.
                  </p>
                  <p>
                    By such a niche product range, ABP is always ready to provide quality solutions to your need, including:
                  </p>
                  <ul>
                    <li>packaging</li>
                    <li>transportation</li>
                    <li>and other manufacturing or processing.</li>
                  </ul>
                  <p><span className="text-logo">ABP Big Bag provides services to many sectors. Some can be listed as:</span></p>
                  <ul>
                    <li>Food</li>
                    <li>Medicine</li>
                    <li>Pharmaceutical</li>
                    <li>Chemistry</li>
                    <li>Transportation</li>
                    <li>Minerals</li>
                    <li>Animal Foods</li>
                    <li>Horticulture/Gardening</li>
                    <li>Agriculture</li>
                    <li>Packaging</li>
                    <li>Mining</li>
                    <li>Waste Transportation</li>
                    <li>Mineral and Animal feed</li>
                  </ul>
                </div>
              </div>

              <div className="col-md-6 align-items-stretch icon-column">
                {/* Wrapper for icon boxes with background image applied via CSS */}
                <div className="icon-boxes-wrapper">
                  {sectorIcons.map((item, index) => (
                    <div className="highlight-item" key={index}> {/* Reusing highlight-item style from about.css */}
                      <div className="highlight-icon">
                        <i className={item.icon}></i>
                        {/* Example using react-fontawesome: <FontAwesomeIcon icon={faFlask} /> */}
                      </div>
                      <div className="highlight-content">
                        <h4><a href={item.link}>{item.name}</a></h4>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>{/* End Services Section */}
      </main>
    </div>
  );
};

export default Sectors;